/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Start_TagInputs */

const en_gc_resources_guide_start_tag = /** @type {(inputs: Gc_Resources_Guide_Start_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting started`)
};

const zh_gc_resources_guide_start_tag = /** @type {(inputs: Gc_Resources_Guide_Start_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入门`)
};

/**
* | output |
* | --- |
* | "Getting started" |
*
* @param {Gc_Resources_Guide_Start_TagInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_start_tag = /** @type {((inputs?: Gc_Resources_Guide_Start_TagInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Start_TagInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_start_tag(inputs)
	return zh_gc_resources_guide_start_tag(inputs)
});
export { gc_resources_guide_start_tag as "gc.resources.guide.start.tag" }